<template>
    <section class="no-targets">
        <h4 class="no-targets__title">
            <span class="material-symbols-outlined">info</span>
            {{ NO_TARGETS_HEADING }}
        </h4>

        <p class="no-targets__intro">{{ NO_TARGETS_INTRO }}</p>
        <p class="no-targets__ref">{{ NO_TARGETS_INTRO_REF }}</p>

        <p class="no-targets__lead">{{ NO_TARGETS_ACTIVITIES_LEAD }}</p>
        <ul class="no-targets__list">
            <li v-for="(activity, index) in NO_TARGETS_ACTIVITIES" :key="index">
                <strong>{{ activity.label }}</strong>
                <span v-if="activity.detail"> &mdash; {{ activity.detail }}</span>
            </li>
        </ul>

        <p class="no-targets__closing">{{ NO_TARGETS_CLOSING }}</p>
        <p class="no-targets__ref">{{ NO_TARGETS_ACTIVITIES_REF }}</p>
    </section>
</template>

<script setup>
import {
    NO_TARGETS_HEADING,
    NO_TARGETS_INTRO,
    NO_TARGETS_INTRO_REF,
    NO_TARGETS_ACTIVITIES_LEAD,
    NO_TARGETS_ACTIVITIES,
    NO_TARGETS_ACTIVITIES_REF,
    NO_TARGETS_CLOSING,
} from '@/utils/assessment-targets';
</script>

<style scoped>
.no-targets {
    background: #f7f6ff;
    border: 1px solid #e4dfff;
    border-left: 4px solid #725CFF;
    border-radius: 10px;
    padding: 18px 20px;
    margin-bottom: 20px;
}

.no-targets__title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 700;
    color: #222;
    margin: 0 0 10px;
}

.no-targets__title .material-symbols-outlined {
    font-size: 20px;
    color: #725CFF;
}

.no-targets__intro,
.no-targets__lead,
.no-targets__closing {
    font-size: 14px;
    line-height: 1.55;
    color: #444;
    margin: 0 0 8px;
}

.no-targets__lead {
    font-weight: 600;
    color: #222;
    margin-top: 12px;
}

.no-targets__list {
    list-style: disc;
    margin: 0 0 10px;
    padding-left: 22px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.no-targets__list li {
    font-size: 14px;
    line-height: 1.5;
    color: #444;
}

.no-targets__list strong {
    color: #222;
    font-weight: 600;
}

.no-targets__ref {
    font-size: 12px;
    color: #777;
    margin: 0 0 4px;
}
</style>
